export default __webpack_public_path__ + "static/media/Hauora-ExtraBold.3fdf8299.woff2";